module.exports = __webpack_public_path__ + "img/defaultProject.ceac8169.jpeg";